module.exports = __webpack_public_path__ + "img/introductionRed.669a2e49.jpg";